import { render, staticRenderFns } from "./categorias.vue?vue&type=template&id=1be0194c"
import script from "./categorias.vue?vue&type=script&lang=js"
export * from "./categorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports